namespace GeniuzPOS.InventoryReport {
    export interface IcReport04_VForm {
    }

    export class IcReport04_VForm extends Serenity.PrefixedContext {
        static formKey = 'InventoryReport.IcReport04_V';
    }
}
